import styled from "styled-components";
import {Link} from "react-scroll";
import {Container} from "../shared";
import logo from './br-logo.png';
import navIcon from './nav-icon.svg';
import 'react-modern-drawer/dist/index.css';


const StyledHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  
  display: flex;
  align-items: center;
  justify-content: center;
  height: 96px;
  z-index: 10000;
  
  background-color: #F9F7F4;
`;

const StyledHeaderInner = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  > img {
    cursor: pointer;
  }
`;

const Header = ({onClickMenu}) => {
  return (
    <StyledHeader>
      <Container>
        <StyledHeaderInner>
          <Link to="top" smooth duration={1000}>
            <img src={logo} width="144px" alt="BurnsRED logo" />
          </Link>
          <img src={navIcon} width="26px" onClick={onClickMenu} aria-label="open navigation" alt="hamburger icon" />
        </StyledHeaderInner>
      </Container>
    </StyledHeader>
  );
}

export default Header;
